(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-benefits-bar]');

    for (const root of roots) {
      if (root.dataset.initialized === 'true') {
        continue;
      }

      root.dataset.initialized = 'true';
    }

    if (!document.querySelector('[data-benefits-bar][data-has-lucide="true"]')) {
      return;
    }

    const loadLucide = () => {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        return Promise.resolve(window.lucide);
      }

      if (window.__benefitsBarLucidePromise) {
        return window.__benefitsBarLucidePromise;
      }

      window.__benefitsBarLucidePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/lucide@latest';
        script.async = true;
        script.onload = () => resolve(window.lucide);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__benefitsBarLucidePromise;
    };

    loadLucide()
      .then((lucide) => {
        if (lucide && typeof lucide.createIcons === 'function') {
          lucide.createIcons({ attrs: { width: 32, height: 32 } });
        }
      })
      .catch(() => {
        /* no-op */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-help-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-floating-help]');

    for (const root of roots) {
      if (root.dataset.initialized === 'true') {
        continue;
      }

      root.dataset.initialized = 'true';

      const panel = root.querySelector('.floating-help__panel');
      const toggle = root.querySelector('.floating-help__toggle');
      const closeButton = root.querySelector('.floating-help__close');

      if (!panel || !toggle || !closeButton) {
        continue;
      }

      const setOpen = (isOpen) => {
        panel.classList.toggle('is-open', isOpen);
        panel.setAttribute('aria-hidden', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? 'Cerrar panel de ayuda' : 'Abrir panel de ayuda');
      };

      toggle.addEventListener('click', () => {
        setOpen(!panel.classList.contains('is-open'));
      });

      closeButton.addEventListener('click', () => {
        setOpen(false);
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) {
          setOpen(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setOpen(false);
        }
      });
    }

    if (!document.querySelector('[data-floating-help][data-has-lucide="true"]')) {
      return;
    }

    const loadLucide = () => {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        return Promise.resolve(window.lucide);
      }

      if (window.__floatingHelpLucidePromise) {
        return window.__floatingHelpLucidePromise;
      }

      window.__floatingHelpLucidePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/lucide@latest';
        script.async = true;
        script.onload = () => resolve(window.lucide);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__floatingHelpLucidePromise;
    };

    loadLucide()
      .then((lucide) => {
        if (lucide && typeof lucide.createIcons === 'function') {
          lucide.createIcons({ attrs: { width: 24, height: 24 } });
        }
      })
      .catch(() => {
        /* no-op */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
